/**
 * @desc 分页查询优惠信息列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.PreferentialInformationPlatformPagingQueryParameters>): Promise<BaseResponse<defs.PageBean<Array<defs.PreferentialInformationPlatform>>>> {
  return fetch({
    url: config.API_HOST + '/base/platPromotion/pageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
